<template>
    <div>
        <van-nav-bar title="Gxpay" left-text="返回" left-arrow @click-left="$router.push('/member/members')" />
        <van-cell-group id="vancellColor">
            <van-cell title="Gxpay 账号" :value="gxpay_account"></van-cell>
            <van-cell title="Gxpay ID" :value="gxpay_id"></van-cell>
            <van-cell title="Gxpay 余额" :value="gxpay_balance"></van-cell>
            <van-cell title="买币" is-link @click="gxpayBuy()"/>
            <van-cell title="卖币" is-link @click="gxpaySell()"/>
            <van-cell title="我的订单" is-link @click="gxpayOrderList()"/>
            <van-cell center><div v-html="gxpayContentDescription"></div></van-cell>
        </van-cell-group>
    </div>
</template>

<script>
export default {
    name: "Gxpay",
    data() {
        return {
            gxpay_account: 0,
            gxpay_id: 0,
            gxpay_balance: 0,
            buyUrl:'',
            sellUrl:'',
            orderListUrl:'',
            gxpayContentDescription:''
        }
    },
    computed: {
    },
    methods: {
        isLogin() {
            let that = this;
            if (!that.$store.state.loginType) {
                that.$router.push('/login')
            }
        },
        getGxpayDigitalCurrency(){
            let that = this;
            that
            .$http({
                url: "/",
                method: "post",
                data: {
                    nozzle: "gxpay_thirdparty_digital_currency",
                    token: sessionStorage.getItem("token")
                }
            })
            .then(function(res) {
                if (res.data.code == 1) {
                    let resData = res.data;
                    that.gxpay_account = resData.data.account;
                    that.gxpay_id = resData.data.numberId;
                    that.gxpay_balance = resData.data.walletDTOList.length>0?resData.data.walletDTOList[0]['money']:0;
                    that.buyUrl = resData.data.buyUrl
                    that.sellUrl = resData.data.sellUrl
                    that.orderListUrl = resData.data.orderListUrl
                } else if (res.data.code == 0 || res.data.code == -1) {
                    that.$toast.fail(res.data.msg);
                }
            });
        },
        gxpayBuy(){
            window.open(this.buyUrl, "_blank");
        },
        gxpaySell(){
            window.open(this.sellUrl, "_blank");
        },
        gxpayOrderList(){
            window.open(this.orderListUrl, "_blank");
        },
        gxpayContentDesc() {
            let that = this;
            that
                .$http({
                url: "/",
                method: "post",
                data: {
                    nozzle: "sysconfig",
                    token: sessionStorage.getItem("token"),
                    name: "gxpay_desc",
                },
                })
                .then(function (res) {
                if (res.data.code == 1) {
                    that.gxpayContentDescription = res.data.data;
                } else if (res.data.code === 0 || res.data.code === -1) {
                    that.$toast.fail(res.data.msg);
                }
                });
        },
    },
    mounted: function () {
        this.isLogin();
        this.getGxpayDigitalCurrency();
        this.gxpayContentDesc();
    }
}
</script>

<style scoped>
.navStyles {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
}
</style>
<style>
#vancellColor .van-cell__value{
    color: #000000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Gxpay.vue